import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import TutorSidebar from '../../TutorSidebar/TutorSidebar'
import TutorFooter from '../../TutorFooter/TutorFooter'
import { Link, useNavigate, useParams } from 'react-router-dom'

import Beatloader from '../../../../Common/BeatLoader';
import toast from 'react-hot-toast';
import { getTutorMyBookedScheduleDetailData } from '../../../../Redux/action/TutorAction';
import moment from "moment-timezone";


const getTimezone = (abb) => {
    const map = {
        PDT: "America/Los_Angeles",
        PST: "America/Los_Angeles",
        MDT: "America/Denver",
        MST: "America/Denver",
        CDT: "America/Chicago",
        CST: "America/Chicago",
        EDT: "America/New_York",
        EST: "America/New_York",
        CET: "Europe/Paris",
        CEST: "Europe/Paris",
        BST: "Europe/London",
        GMT: "Etc/GMT",
        JST: "Asia/Tokyo",
        KST: "Asia/Seoul",
        HKT: "Asia/Hong_Kong",
        SGT: "Asia/Singapore",
        MYT: "Asia/Kuala_Lumpur",
        ICT: "Asia/Bangkok",
        PKT: "Asia/Karachi",
        GST: "Asia/Dubai",
        AST: "Asia/Riyadh",
        AEST: "Australia/Sydney",
        AEDT: "Australia/Sydney",
        ACST: "Australia/Adelaide",
        AWST: "Australia/Perth",
        EAT: "Africa/Nairobi",
        CAT: "Africa/Harare",
        WAT: "Africa/Lagos",
        BRT: "America/Sao_Paulo",
        ART: "America/Argentina/Buenos_Aires",
        NZST: "Pacific/Auckland",
        NZDT: "Pacific/Auckland"
    };

    return map[abb] || moment.tz.guess();
};


const host = process.env.REACT_APP_API_SERVER

const TutorScheduleGroupDetails = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { b64id } = useParams();

    useEffect(() => {
        try {

            let requestId = atob(b64id);

            if (!requestId || isNaN(requestId)) {
                throw new Error("Invalid course ID");
            }

            dispatch(getTutorMyBookedScheduleDetailData(requestId))
        } catch (error) {

            navigate(-1);
        }
    }, [b64id]);

    const {
        loadingTutorMyBookedScheduleDetailApi,
        TutorMyBookedScheduleDetailApiData,
        TutorMyBookedScheduleDetailApiError
    } = useSelector(state => state?.TutorReducer);


    // const handleJoinMeeting = (start_date, start_timeee, start_time, end_time, link, meeting_provider,session_id) => {

    //     const sessionStartDateTime = new Date(start_time);

    //     const sessionEndDateTime = new Date(end_time);

    //     const currentDateTime = new Date();

    //     // Determine meeting status
    //     if (currentDateTime < sessionStartDateTime) {
    //         toast.success(
    //             <div>Meeting starts on {start_date} {start_timeee}</div>
    //         );
    //     } else if (currentDateTime > sessionEndDateTime) {
    //         toast.error(
    //             <div>Meeting link expired</div>
    //         );
    //     } else {
    //         // Allow joining if within valid time window
    //         if (meeting_provider == 'gmeet') {
    //             window.open(link, '_blank', 'noopener,noreferrer');

    //         }
    //         else {
    //             navigate(`/show-meeting`, {
    //                 state: {
    //                     authToken: localStorage.getItem('tutor-token'),
    //                     meetingLink: link,
    //                     end_time: end_time,
    //                     course_id: TutorMyBookedScheduleDetailApiData?.course?.id,
    //                 meeting_session_id: session_id
    //                 },
    //             });
    //         }
    //     }
    // };

    const handleJoinMeeting = (
        start_date,
        start_timeee,
        start_time,
        end_time,
        link,
        meeting_provider,
        session_id,
        timeZoneAbb
    ) => {

        const timezone = getTimezone(timeZoneAbb);

        const sessionStart = moment.tz(start_time, timezone).valueOf();
        const sessionEnd = moment.tz(end_time, timezone).valueOf();
        const currentTime = moment().valueOf();

         const joinBefore = moment(sessionStart).subtract(5, "minutes").valueOf();

        if (currentTime < joinBefore) {

            toast.success(
                <div>Meeting starts on {start_date} {start_timeee}</div>
            );

        } else if (currentTime > sessionEnd) {

            toast.error(<div>Meeting link expired</div>);

        } else {

            if (meeting_provider === "gmeet") {

                window.open(link, "_blank", "noopener,noreferrer");

            } else {

                navigate(`/show-meeting`, {
                    state: {
                        authToken: localStorage.getItem("tutor-token"),
                        meetingLink: link,
                        end_time: sessionEnd,
                        course_id: TutorMyBookedScheduleDetailApiData?.course?.id,
                        meeting_session_id: session_id,
                        role: "host"
                    }
                });

            }
        }
    };

    return (
        <div>
            <section className="after-header">
                {/* Breadcrum Start */}
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb bg-light">
                        <li className="breadcrumb-item  ps-5" aria-current="page">
                            <Link to="javascript:history.back()">
                                <i className="fa-solid fa-chevron-left text-dark" />
                            </Link>
                            &nbsp;&nbsp;My Schedule Details
                        </li>
                    </ol>
                </nav>
                {/* Breadcrum End */}
                <div className="main-container-sec">
                    <div className="row mx-0">
                        <div className="col-lg-3">
                            <TutorSidebar />
                        </div>
                        <div className="col-lg-9">
                            <main className="px-3 py-4">
                                {loadingTutorMyBookedScheduleDetailApi ?
                                    <Beatloader />
                                    :
                                    <div className="my-schedule-detail-sec">
                                        <div className="row align-items-baseline">
                                            <div className="col-lg-2">
                                                <img
                                                    src={`${ host }${ TutorMyBookedScheduleDetailApiData?.student?.profile_img }`}
                                                    className="img-fluid w-auto"
                                                    style={{ borderRadius: 15 }}
                                                    onError={(e) => {
                                                        e.target.src = '/assets/img/user/user.png'; // Fallback image
                                                    }}
                                                />
                                            </div>
                                            <div className="col-lg-7">
                                                <h4 className="mb-0">{TutorMyBookedScheduleDetailApiData?.student?.name}</h4>
                                                <p className="mb-0 text-primary fw-bold">{TutorMyBookedScheduleDetailApiData?.course?.childcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0 mt-2 fw-bold">
                                                    <i className="fa-solid fa-calendar-days" /> Scheduled Date
                                                </p>
                                                <p className="mb-0 ms-4 text-primary fw-bold"> {TutorMyBookedScheduleDetailApiData?.course?.batches?.batch_start_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-4 mb-3">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Class/Grade/General</p>
                                                <p className="mb-0 fw-bold">{TutorMyBookedScheduleDetailApiData?.course?.category?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Subject</p>
                                                <p className="mb-0 fw-bold">{TutorMyBookedScheduleDetailApiData?.course?.subcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Module</p>
                                                <p className="mb-0 fw-bold">{TutorMyBookedScheduleDetailApiData?.course?.childcategory?.name}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Course Name</p>
                                                <p className="mb-0 fw-bold">{TutorMyBookedScheduleDetailApiData?.course?.name}</p>
                                            </div>
                                        </div>
                                        <div className="row mb-4">
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session Start date</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorMyBookedScheduleDetailApiData?.course?.batches?.batch_start_date}</p>
                                            </div>
                                            <div className="col-lg-3">
                                                <p className="mb-0">Session End date</p>
                                                <p className="mb-0 fw-bold text-primary">{TutorMyBookedScheduleDetailApiData?.course?.batches?.batch_end_date}</p>
                                            </div>
                                        </div>
                                        <div className="row mt-5">
                                            {TutorMyBookedScheduleDetailApiData?.course?.batches?.batchSession?.map((data) => (

                                                <div className="col-lg-4 my-2">
                                                    <div className="card bg-light" style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                                                        <div className="card-body d-flex flex-column">
                                                            <div className='d-flex justify-content-between'>
                                                                <h6>Start Date: {data?.batch_start_date}  </h6>
                                                                <Link
                                                                    to={`/tutor/recordings/${ btoa(TutorMyBookedScheduleDetailApiData?.course?.batches?.meetting_link) }`}
                                                                    state={{ course: TutorMyBookedScheduleDetailApiData?.course?.name }}
                                                                > <i className='fa fa-download'></i></Link>
                                                            </div>
                                                            <h6>
                                                                Time Slot: {data?.time_slot?.formated_start_time} - {data?.time_slot?.formated_end_time} ({data?.time_slot?.timeZoneAbb})
                                                            </h6>
                                                            <h6>Topic Details: {data?.topic_details}</h6>
                                                            <div className="mt-auto">
                                                                {/* {new Date(data?.time_slot?.new_end_date_time) >= new Date() ? ( */}

                                                                {moment.tz(
                                                                    data?.time_slot?.new_end_date_time,
                                                                    getTimezone(data?.time_slot?.timeZoneAbb)
                                                                ).isAfter(moment().tz(getTimezone(data?.time_slot?.timeZoneAbb))) ? (

                                                                    <button className="btn btn-primary" onClick={() => {
                                                                        // handleJoinMeeting(
                                                                        //     data?.batch_start_date,
                                                                        //     data?.time_slot?.formated_start_time,
                                                                        //     data?.time_slot?.new_start_date_time,
                                                                        //     data?.time_slot?.new_end_date_time,

                                                                        //     TutorMyBookedScheduleDetailApiData?.course?.batches?.meetting_link,
                                                                        //     TutorMyBookedScheduleDetailApiData?.course?.batches?.meeting_provider,
                                                                        //     data?.id
                                                                        // )
                                                                        handleJoinMeeting(
                                                                            data?.batch_start_date,
                                                                            data?.time_slot?.formated_start_time,
                                                                            data?.time_slot?.new_start_date_time,
                                                                            data?.time_slot?.new_end_date_time,
                                                                            TutorMyBookedScheduleDetailApiData?.course?.batches?.meetting_link,
                                                                            TutorMyBookedScheduleDetailApiData?.course?.batches?.meeting_provider,
                                                                            data?.id,
                                                                            data?.time_slot?.timeZoneAbb
                                                                        )
                                                                    }}>Join Meeting</button>

                                                                ) : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            ))}
                                        </div>
                                    </div>
                                }
                            </main>

                        </div>
                    </div>
                </div>
            </section>


        </div>
    )
}

export default TutorScheduleGroupDetails